import { render, staticRenderFns } from "./InfoBtn.vue?vue&type=template&id=3874fa67&"
import script from "./InfoBtn.vue?vue&type=script&lang=js&"
export * from "./InfoBtn.vue?vue&type=script&lang=js&"
import style0 from "./InfoBtn.vue?vue&type=style&index=0&id=3874fa67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports